import React, { FC } from 'react';
import { styled } from '@mui/material/styles';
import { Fade, Zoom, Box } from '@mui/material';
import TextControlBar from 'Components/WelcomeSlides/TextControlBar';
import {
  PageContainer,
  Headline,
  Item,
  ItemIcon,
  ItemIconContainer,
  ItemText,
  ContentContainer,
  ImageContainer,
} from './styles';
import pulseLine from 'assets/img/welcomeSlides/pulse-line-2.svg';
import { ThemeTypography } from 'DesignSystem';
import chain from 'assets/img/welcomeSlides/icon_supply_chain.svg';
import PhoneScreen from 'Components/PhoneScreen/PhoneScreen';
import welcomeSlideGif from 'assets/img/welcomeSlides/product-journey-recording-2024.gif';

interface IVisualizeChainProps {
  active: boolean;
}

const StyledPulse = styled('img')(({ theme }) => ({
  position: 'absolute',
  left: theme.spacing(0),
  width: '380px !important',
  bottom: 35,
}));

const VisualizeChain: FC<IVisualizeChainProps> = ({ active }) => {
  return (
    <>
      <PageContainer>
        <Zoom in={active}>
          <ContentContainer>
            <Box mb={1.5}>
              <Item>
                <ItemIconContainer>
                  <ItemIcon width={26} src={chain} alt="Supply chain icon" />
                </ItemIconContainer>
                <ItemText
                  dangerouslySetInnerHTML={{ __html: 'Visualize your <br /> Supply chain' }}
                />
              </Item>
            </Box>
            <Headline variant="TITLE_LARGE">Become transparent</Headline>
            <ThemeTypography variant="TITLE_EXTRA_SMALL">
              Take your customers on a journey to the origins of your products.
            </ThemeTypography>
            <Zoom in={active}>
              <StyledPulse src={pulseLine} alt="pulse" />
            </Zoom>
          </ContentContainer>
        </Zoom>
        <Fade in={active} timeout={400}>
          <ImageContainer>
            <PhoneScreen height={460}>
              <img src={welcomeSlideGif} height="100%" width="100%" alt="screen-preview" />
            </PhoneScreen>
          </ImageContainer>
        </Fade>
      </PageContainer>
      <TextControlBar />
    </>
  );
};

export default VisualizeChain;
